import { Link } from 'react-router-dom';
import type { MangaItem } from '@/mocks/manga';

interface MangaCardProps {
  manga: MangaItem;
  size?: 'normal' | 'large';
}

export default function MangaCard({ manga, size = 'normal' }: MangaCardProps) {
  const imageHeight = size === 'large' ? 'h-72' : 'h-56';

  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`relative ${imageHeight} rounded-lg overflow-hidden mb-3 bg-background-200`}>
        <img
          src={manga.coverImage}
          alt={manga.title}
          title={`${manga.title} - 樱花漫画 ${manga.category}推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute top-2 left-2 flex gap-1.5">
          {manga.isHot && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
              热门
            </span>
          )}
          {manga.isNew && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500 text-white whitespace-nowrap">
              新作
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 text-[10px] font-medium rounded-full ${
            manga.status === '连载中'
              ? 'bg-secondary-500 text-white'
              : 'bg-foreground-600 text-white'
          } whitespace-nowrap`}>
            {manga.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1.5 text-white/90">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
            </div>
            <span className="text-xs font-medium">{manga.rating}</span>
            <span className="text-white/50 text-xs ml-auto">{manga.views >= 10000 ? `${(manga.views / 10000).toFixed(0)}万` : manga.views} 阅读</span>
          </div>
        </div>
      </div>

      <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 whitespace-nowrap overflow-hidden text-ellipsis">
        {manga.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
        {manga.author} · {manga.category}
      </p>
    </Link>
  );
}